export const arrow = (
  <svg width="15" height="15" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6.5 10.5L9.5 7.5L6.5 4.5" stroke="white" strokeLinecap="square" />
  </svg>
);
